export function decodeJwt(token) {
  if (!token) return null

  try {
    var parts = token.split('.')
    if (parts.length !== 3) return null

    var encodedPayload = parts[1]
    var json = atob(encodedPayload)
    var decoded = JSON.parse(json)

    return decoded
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('Invalid token')
    return null
  }
}
